/*! Created by: Udo Schmal | https://www.gocher.me/ */
(function() {
  'use strict';
  function Pages(pageslist) {
    var store = 'pages-' + window.location.pathname;
    var self = pageslist;
    var current = 0;
    var pages = pageslist.children;
    var maxlength = 5;
    var previous, next, placeholderPrevious, placeholderNext;
    var pagination = [];
    var navi = document.createElement("ul");
    navi.className = "paginator";
    pageslist.parentNode.insertBefore(navi, pages.nextSibling);
    function updateBefore() {
      pagination[current].classList.remove("current");
      pages[current].classList.remove("current");
    }
    function updateAfter() {
      if (pages.length > 5) {
        if (current == 0) {
          previous.classList.add('hidden');
          previous.style.visibility = 'hidden';
        } else {
          previous.classList.remove('hidden');
          previous.style.visibility = '';
        }
        if (current < 4) {
          placeholderPrevious.classList.add('none');
          placeholderPrevious.style.display = 'none';
        } else {
          placeholderPrevious.classList.remove('none');
          placeholderPrevious.style.display = '';
        }
        if (current < 2) {
          for (var i=1; i < pages.length-1; i++) {
            if (i > 4) {
              pagination[i].classList.add('none');
              pagination[i].style.display = 'none';
            } else {
              pagination[i].classList.remove('none');
              pagination[i].style.display = '';
            }
          }
        } else if (current > pages.length-3) {
          for (var i=1; i < pages.length-1; i++) {
            if (i < pages.length-5) {
              pagination[i].classList.add('none');
              pagination[i].style.display = 'none';
            } else {
              pagination[i].classList.remove('none');
              pagination[i].style.display = '';
            }
          }
        } else {
          for (var i=1; i < pages.length-1; i++) {
            if ((i < current-2) || (i > current+2)) {
              pagination[i].classList.add('none');
              pagination[i].style.display = 'none';
            } else {
              pagination[i].classList.remove('none');
              pagination[i].style.display = '';
            }
          }
        }
        if (current > pages.length-5) {
          placeholderNext.classList.add('none');
          placeholderNext.style.display = 'none';
        } else {
          placeholderNext.classList.remove('none');
          placeholderNext.style.display = '';
        }
        if (current == pages.length-1) {
          next.classList.add('hidden');
          next.style.visibility = 'hidden';
        } else {
          next.classList.remove('hidden');
          next.style.visibility = '';
        }
      }
      sessionStorage.setItem(store, current);
      pagination[current].classList.add("current");
      pages[current].classList.add("current");
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    function btn(event) {
      updateBefore();
      if (this.classList.contains('previous')) {
        current = current > 0 ? current - 1 : 1;
      } else {
        current = current < pages.length-1 ? current + 1 : pages.length-1;
      }
      updateAfter();
      event.stopPropagation();
    }
    function toggle(event) {
      updateBefore();
      current = this.pageid;
      updateAfter();
      event.stopPropagation();
    }
    if (pages.length > 5) {
      previous = document.createElement("li");
      previous.className = 'previous';
      previous.addEventListener('mousedown', btn);
      navi.appendChild(previous);
    }
    var item;
    for (var i=0; i<pages.length; i++) {
      if (pages[i].classList.contains("current")) {
        current = i;
      };
      item = document.createElement("li");
      item.appendChild(document.createTextNode(i+1));
      item.pageid = i;
      navi.appendChild(item);
      item.addEventListener('mousedown', toggle);
      pagination.push(item);
      if (pages.length > 5) {
        if (i==0) {
          placeholderPrevious = document.createElement("li");
          placeholderPrevious.className = 'placeholder';
          placeholderPrevious.appendChild(document.createTextNode('...'));
          navi.appendChild(placeholderPrevious);
        }
        if (i==pages.length-2) {
          placeholderNext = document.createElement("li");
          placeholderNext.className = 'placeholder';
          placeholderNext.appendChild(document.createTextNode('...'));
          navi.appendChild(placeholderNext);
        }
      }
    }
    if (pages.length > 5) {
      next = document.createElement("li");
      next.className = 'next';
      next.addEventListener('mousedown', btn);
      navi.appendChild(next);
    }
    if (sessionStorage.getItem(store)) {
      current = sessionStorage.getItem(store);
    }
    updateAfter();
  }
  var pagesList = document.querySelectorAll("ul[data-type='pages']");
  for (var i=0; i<pagesList.length; i++) {
    new Pages(pagesList[i]);
  }
})();
